import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Cell } from 'sarsaparilla';
import { Durations } from '../constants';
import { PassTypeProps } from '../props';
import { validToDate } from '../utils/duration_utils';
import { TextInput, SimpleDatePicker } from '../../../ui-lottery/src/components/inputs';

const propTypes = {
  startDate: PropTypes.string,
  passType: PassTypeProps.isRequired,
  onChange: PropTypes.func.isRequired
};

const defaultProps = {
  startDate: ''
};

export default class StartDateForm extends PureComponent {
  constructor(props) {
    super(props);

    this.onStartDateChanged = this.onStartDateChanged.bind(this);
  }

  componentDidMount() {
    this.props.onChange(this.props.startDate || moment().format(), true);
  }

  componentWillUnmount() {
    this.props.onChange(this.props.startDate, true);
  }

  onStartDateChanged(date) {
    this.props.onChange(date.startOf('day').format(), true);
  }

  render() {
    const { passType, startDate: startDateString } = this.props;
    let startDate;
    let startDateInput;

    if (passType.features.indexOf('start-date') !== -1) {
      startDate = !startDateString ? moment() : moment(startDateString);

      startDateInput = (
        <SimpleDatePicker
          label={'Pass Start Date'}
          id={'start-date'}
          date={startDate}
          onChange={this.onStartDateChanged} />
      );
    }
    else {
      startDate = moment();
      startDateInput = <TextInput id={'start-date'} value={startDate.format('ll')} label="Pass Start Date" readOnly />;
    }

    const endDate = validToDate(startDate, Durations[passType.duration]);

    return (
      <Row>
        <Cell width={6}>
          {startDateInput}
        </Cell>
        <Cell width={6}>
          <TextInput id={'through-date'} value={endDate.format('ll')} label="Pass Valid Through" readOnly />
        </Cell>
      </Row>
    );
  }
}

StartDateForm.propTypes = propTypes;
StartDateForm.defaultProps = defaultProps;
